export function humanizedDuration(seconds) {
    const mins = Math.floor(seconds / 60)
    const hrs = Math.floor(mins / 60)

    if (seconds === 0)
        return `${seconds} ore`

    if (hrs > 0) {
        const remMins = mins % 60
        return remMins > 0
            ? `${hrs} or${hrs > 1 ? 'e' : 'a'} ${remMins} min`
            : `${hrs} or${hrs > 1 ? 'e' : 'a'}`
    }

    if (mins > 0) {
        return `${mins} minut${mins > 1 ? 'i' : 'o'}`
    }

    return `${seconds} secondi`
}

export function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max)
}

export function compactHumanizedDuration(seconds) {
    const safeSeconds = Math.max(0, Number(seconds || 0));
    const mins = Math.floor(safeSeconds / 60);
    const hrs = Math.floor(mins / 60);
    const remMins = mins % 60;

    if (hrs > 0) {
        return remMins > 0 ? `${hrs}h ${remMins}m` : `${hrs}h`;
    }

    if (mins > 0) {
        return `${mins}m`;
    }

    return `${safeSeconds}s`;
}
